import { PageContent, PageHeader, Space } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { NavigateCreatePageButton } from '../_components/NavigateCreatePageButton';
import { GroupsPage } from '../groups/_pages/GroupsPage';
import { ProjectGroupPage } from '../groups/group-detail/_pages/ProjectGroupPage';
import { ProjectsPageDynamicLink } from './_components/ProjectsPageDynamicLink';
import { ProjectsProvider } from './_components/ProjectsProvider';
import { ProjectsPage } from './_pages/ProjectsPage';
import { ReportProjectPage } from './project-detail/fund/_components/ReportProjectPage';
import { ProjectDetailRoutes } from './project-detail/routes';
import { CreateProjectPage } from './upsert-form/_pages/CreateProjectPage';

export const ProjectsRoutes = () => {
  const { t } = useTranslation();
  return (
    <ProjectsProvider>
      <Routes>
        <Route
          index
          element={
            <>
              <PageHeader
                title={t('projects-page')}
                breadcrumbs={[{ title: t('projects-page') }]}
                buttons={
                  <Space>
                    {/* <NavigateReportPageButton /> */}
                    <ProjectResourceGuard onlyEdit>
                      <Space>
                        <NavigateCreatePageButton text={t('create-project')} />
                      </Space>
                    </ProjectResourceGuard>
                  </Space>
                }
              />
              <PageContent>
                <ProjectsPage />
              </PageContent>
            </>
          }
        />
        <Route
          path="/report"
          element={
            <>
              <PageHeader
                title={t('report-projects-page')}
                breadcrumbs={[
                  { title: <ProjectsPageDynamicLink /> },
                  {
                    title: t('report-projects-page'),
                  },
                ]}
              />
              <PageContent>
                <ReportProjectPage />
              </PageContent>
            </>
          }
        />
        <Route path="/:id/*" element={<ProjectDetailRoutes />} />
        <Route
          path="/new"
          element={
            <ProjectResourceGuard onlyEdit>
              <PageHeader
                title={t('create-project-page')}
                breadcrumbs={[
                  { title: <ProjectsPageDynamicLink /> },
                  { title: t('create-project-page') },
                ]}
              />
              <PageContent>
                <CreateProjectPage />
              </PageContent>
            </ProjectResourceGuard>
          }
        />
        <Route path="/group" element={<GroupsPage />} />
        <Route path="/group/:id" element={<ProjectGroupPage />} />
      </Routes>
    </ProjectsProvider>
  );
};
